/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'CaseProgramsProductDeliveries' store object.
 * @namespace CaseProgramsProductDeliveriesSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UACaseProgramsProductDeliveries';

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof CaseProgramsProductDeliveriesSelectors
   */
  static isFetchingGetAcesCaseProgramsProductDeliveriesByCaseId = state =>
    state[selectors.moduleIdentifier].isFetchingGetAcesCaseProgramsProductDeliveriesByCaseId
      .payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof CaseProgramsProductDeliveriesSelectors
   */
  static getAcesCaseProgramsProductDeliveriesByCaseIdError = state =>
    state[selectors.moduleIdentifier].getAcesCaseProgramsProductDeliveriesByCaseIdError.payload;
}
